import type { RGBColor } from 'react-color';

function colorObjToString(color: RGBColor): string {
  const { r, g, b, a = 1 } = color;
  return `${r},${g},${b},${a}`;
}

export default colorObjToString;
